import * as React from 'react';

const Box = ({ children, sx = {}, style = {}, ...rest }) => {
  const combined = {
    boxSizing: 'border-box',
    fontFamily: 'inherit',
    ...sx,
    ...style,
  };
  return (
    <div style={combined} {...rest}>
      {children}
    </div>
  );
};

function Slider({
  defaultValue = 0,
  min = 0,
  max = 100,
  step = 1,
  marks = false,
  disabled = false,
  description = [],
  getAriaValueText,
  valueLabelDisplay,
  'aria-label': ariaLabel,
  shiftStep,
  value: controlledValue,
  onChange: controlledOnChange,
  ...rest
}) {
  const [internalValue, setInternalValue] = React.useState(defaultValue);
  const value = controlledValue !== undefined ? controlledValue : internalValue;
  const setValue = controlledOnChange || setInternalValue;
  const text = getAriaValueText ? getAriaValueText(value, description) : String(value);

  const marksArray = marks
    ? Array.from({ length: Math.floor((max - min) / step) + 1 }, (_, i) => min + i * step)
    : null;

  const percent = max - min > 0 ? ((value - min) / (max - min)) * 100 : 0;
  const trackBackground = `linear-gradient(90deg, #1e90ff ${percent}%, #e0e0e0 ${percent}%)`;

  return (
    <div style={{ padding: 8 }}>
      {/* slider-specific styles for thumb/track */}
      <style>{`
                .blue-slider {
                    -webkit-appearance: none;
                    appearance: none;
                    height: 10px;
                    border-radius: 3px;
                    background-clip: padding-box;
                    outline: none;
                    font-family: inherit;
                }
                .blue-slider:disabled {
                    opacity: 0.6;
                }
                .blue-slider::-webkit-slider-runnable-track {
                    height: 8px;
                    border-radius: 3px;
                    background: transparent;
                }
                .blue-slider::-webkit-slider-thumb {
                    -webkit-appearance: none;
                    appearance: none;
                    width: 22px; 
                    height: 22px;
                    margin-top: -8px;
                    border-radius: 50%;
                    background: #4F96ED;
                    border: 2px solid #4F96ED;
                    box-shadow: 0 0 2px rgba(0,0,0,0.2);
                    cursor: pointer;
                }

                /* Firefox styles */
                .blue-slider::-moz-range-track {
                    height: 6px;
                    border-radius: 3px;
                    background: transparent;
                }
                .blue-slider::-moz-range-thumb {
                    width: 22px;
                    height: 22px;
                    border-radius: 50%;
                    background: #1e90ff;
                    border: 2px solid white;
                    box-shadow: 0 0 2px rgba(0,0,0,0.2);
                    cursor: pointer;
                }

                /* For IE/Edge legacy if needed */
                .blue-slider::-ms-track {
                    height: 6px;
                    border-radius: 3px;
                    background: transparent;
                    border-color: transparent;
                    color: transparent;
                }
                .blue-slider::-ms-thumb {
                    width: 22px;
                    height: 22px;
                    border-radius: 50%;
                    background: #4F96ED;
                    border: 2px solid #4F96ED;
                    box-shadow: 0 0 2px rgba(0,0,0,0.2);
                }
            `}</style>

      {valueLabelDisplay === 'auto' && (
        <div
          style={{
            textAlign: 'center',
            marginBottom: 6,
            fontSize: 12,
            fontFamily: 'inherit',
          }}
        >
          {text}
        </div>
      )}
      <input
        type="range"
        className="blue-slider"
        min={min}
        max={max}
        step={step}
        disabled={disabled}
        value={value}
        onChange={(e) => setValue(Number(e.target.value))}
        aria-label={ariaLabel}
        {...rest}
        style={{
          width: '100%',
          background: trackBackground,
          fontFamily: 'inherit',
        }}
      />
      {marksArray && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: 6,
          }}
        >
          {marksArray.map((m) => (
            <span key={m} style={{ fontSize: 11, fontFamily: 'inherit' }}>
              {m}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}

function valuetext(value, description) {
  return description[value - 1];
}

function SliderInput({ description, value, onChange }) {
  return (
    <Box>
      <Slider
        aria-label="Value"
        defaultValue={3}
        getAriaValueText={valuetext}
        valueLabelDisplay="auto"
        shiftStep={1}
        description={description}
        step={1}
        marks
        min={1}
        max={5}
        value={value}
        onChange={onChange}
      />
    </Box>
  );
}

export default SliderInput;
